import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/courses/:courseId/activities/:activityId/discussion/create',
        component: () => import('@/pages/courses/activities/DiscussionThreadCreate.vue'),
        props: true,
        children: [
            {
                name: 'discussion-thread-create',
                path: '',
                component: () => import('@/components/discussion/DiscussionThreadForm.vue'),
                meta: {
                    title: 'Create Discussions',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'create', subject: 'discussion thread' },
                },
            },
        ],
    },
    {
        path: '/courses/:courseId/activities/:activityId/discussion/:id',
        component: () => import('@/pages/courses/activities/DiscussionThread.vue'),
        props: true,
        children: [
            {
                name: 'discussion-thread-view',
                path: '',
                component: () => import('@/components/discussion/DiscussionThreadView.vue'),
                meta: {
                    title: 'Discussions',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'discussion thread' },
                },
            },
        ],
    },
];
